import { Heading } from '@backyard-ui/core';

import { Markdown } from '@/presenters/components/common/Markdown';

interface DescriptionProps {
  content: string;
}

const Description = (props: DescriptionProps) => {
  const { content } = props;

  if (!content) {
    return null;
  }

  return (
    <>
      <Heading size="md" asChild>
        <h2>Descrição</h2>
      </Heading>
      <Markdown content={content} />
    </>
  );
};

export default Description;
